import axios from "axios";

let abstractApi = axios.create({
    headers: {
        'locale': 'en',
        'x-api-key': localStorage.getItem('x-api-key')
    }
});

export default {
    namespaced: true,
    state: {},
    actions: {
        GET_PAYMENT_STATUS: function ({commit}, id) {
            return abstractApi.get(process.env.VUE_APP_API_URL + '/payment/status/' + id,)
        },
        PAYMENT_PROCESS: (state, id) => {
            return abstractApi.get(process.env.VUE_APP_API_URL + '/payment/status/setprocess/' + id)
        },
        START_PAYMENT_CHECKOUT: (state, control) => {
            return axios.post(process.env.VUE_APP_API_URL + '/payment/stripe/checkout/' + control.abstract_id, control, {
                headers: {
                    'locale': 'en',
                    'x-api-key': localStorage.getItem('x-api-key')
                }
            })
        },
        GET_INVOICE: (state, id) => {
            return abstractApi.get(process.env.VUE_APP_API_URL + '/payment/stripe/invoice/' + id)
        },
    },
    mutations: {},
    getters: {}
}
